module.exports = __webpack_public_path__ + "img/facial_hair_chin_mustache_thick_extra_heart_mask.3762f2a0.png";